module.exports = __webpack_public_path__ + "img/logo_blue.93cf60e3.png";